// @flow
import { APICore } from './apiCore';
import config from '../../config';

const api = new APICore();

function getAllUsersAdmin(query: string): any {
    let baseUrl = config.USERS_URL + '/admin';

    if (query) {
        baseUrl += `?${query}`;
    }

    return api.get(`${baseUrl}`);
}

export { getAllUsersAdmin };
